import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import './index.css'
import OpenAccountImg from '../../imgs/guidePage_openAccount.png';
import tradeImg from '../../imgs/guidePage_trade.png'
import icon_guidePage from '../../imgs/icon_guidePage.png'

export const GuidePageType = {
    OpenAccount: 'OPENACCOUNT', //开户
    Trade: "TRADE", //交易
}

 class imgPage extends Component{
	constructor(props) {
	    super(props);
	    this.state = {};
        this.guideType = this.props.location.state.type
  	}

    onCloseView = () => {
        hashHistory.goBack();
    }
	render(){
		return(
			<div className='guide_page'>
                <div className='guide_page_top'></div>
                <div className='guide_page_close' onClick={this.onCloseView}>
                    <img className='guide_page_image_icon' src={icon_guidePage}/>
                </div>
                {
                    this.guideType === GuidePageType.OpenAccount ? (
                        <img className='guide_page_image' src={OpenAccountImg} />
                    ) : (
                        <img className='guide_page_image' src={tradeImg} />
                    )
                }
            </div>
		)
	}
}
function mapStateToProps(state, ownProps) {
    return {
      
    }
  }
  
  export default connect(mapStateToProps)(imgPage);


// WEBPACK FOOTER //
// ./src/components/guidePage/imgPage.js